import React, {useEffect} from 'react';
import {Form, Input, Modal} from 'antd';
import userApi from '../api/userApi';

// http(s) URL만 허용
const isHttpUrl = (v) => {
  if (!v) return true;
  try { const u = new URL(v); return u.protocol === 'http:' || u.protocol === 'https:'; } catch { return false; }
};

const UserCreateEditModal = ({ open, mode = 'create', record, onSuccess, onCancel }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) return;
    if (mode === 'edit' && record) {
      form.setFieldsValue({
        lgnUserNm: record.lgnUserNm,
        userNm: record.userNm,
        profileUrl: record.profileUrl,
        eml: record.eml,
        pswd: ''
      });
    } else {
      form.resetFields();
    }
  }, [open, mode, record, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (mode === 'edit' && record?.userId) {
        await userApi.updateUser(record.userId, {
          userNm: values.userNm,
          profileUrl: values.profileUrl,
          eml: values.eml,
          pswd: values.pswd || undefined,
        });
      } else {
        await userApi.signup({
          lgnUserNm: values.lgnUserNm,
          userNm: values.userNm,
          profileUrl: values.profileUrl,
          eml: values.eml,
          pswd: values.pswd,
        });
      }
      onSuccess?.();
    } catch (_) { /* validation or api error handled upstream */ }
  };

  return (
    <Modal
      open={open}
      title={mode === 'edit' ? '사용자 수정' : '사용자 생성'}
      okText="저장"
      cancelText="취소"
      onOk={handleOk}
      onCancel={onCancel}
      destroyOnClose
    >
      <Form layout="vertical" form={form}>
        {mode === 'create' && (
          <Form.Item
            name="lgnUserNm"
            label="로그인ID"
            rules={[{ required: true, message: '로그인ID를 입력하세요.' }]}
          >
            <Input maxLength={60} />
          </Form.Item>
        )}

        <Form.Item
          name="userNm"
          label="사용자명"
          rules={[{ required: true, message: '사용자명을 입력하세요.' }]}
        >
          <Input maxLength={100} />
        </Form.Item>

        <Form.Item
          name="profileUrl"
          label="프로필URL"
          rules={[{ validator: async(_, v) => { if (!v) return; if (!isHttpUrl(v)) throw new Error('http(s) 프로토콜의 올바른 URL을 입력하세요.'); } }]}
        >
          <Input maxLength={500} placeholder="https://example.com/profile.png" />
        </Form.Item>

        <Form.Item
          name="eml"
          label="이메일"
          rules={[{ required: true, message: '이메일을 입력하세요.' }, { type: 'email', message: '유효한 이메일을 입력하세요.' }]}
        >
          <Input maxLength={200} />
        </Form.Item>

        <Form.Item
          name="pswd"
          label={mode === 'edit' ? '비밀번호(변경 시 입력)' : '비밀번호'}
          rules={mode === 'create' ? [{ required: true, message: '비밀번호를 입력하세요.' }] : []}
        >
          <Input.Password maxLength={100} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UserCreateEditModal;
